<template>
  <div id="app">
    <nav class="navbar navbar-expand-md navbar-light bg-light fixed-top"
         v-if="!['/', '/login', '/register'].includes(this.$router.currentRoute.path)">
      <a class="navbar-brand" href="#">Ostfriesland programmiert</a>
      <button class="navbar-toggler" id="navbarToggler" type="button" data-toggle="collapse"
              data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav">
          <li class="nav-item" v-for="link in navLinks">
            <slot v-if="link.show">
              <router-link class="nav-link" :to="link.to"
                           v-if="link.to">{{link.title}}
              </router-link>
              <a class="nav-link" v-on:click="link.action" v-else>{{link.title}}</a>
            </slot>
          </li>
        </ul>
      </div>
    </nav>

    <router-view/>
  </div>

</template>

<script>
    import {AUTH_LOGOUT} from "./store/actions/auth";

    export default {
        created() {
            if (document.getElementById('navbarCollapse')) {
                document.addEventListener('click', (event) => {
                    let clickedOnNav = false;

                    event.target.classList.forEach(x => {
                        if (x.match('nav')) {
                            clickedOnNav = true;
                        }
                    });

                    if (document.getElementById('navbarCollapse').classList.contains("show") && !clickedOnNav) {
                        document.getElementById('navbarToggler').click();
                    }
                });
            }
        },
        methods: {
            signOut: function () {
                this.$store.dispatch(AUTH_LOGOUT).then(() => {
                    this.$router.push('/');
                });
            }
        },
        watch: {
            $route(to, from) {
                if (document.getElementById('navbarCollapse')
                    && document.getElementById('navbarCollapse').classList.contains("show")) {
                    document.getElementById('navbarToggler').click();
                }
            }
        },
        computed: {
            navLinks() {
                return [
                    {
                        title: 'Home',
                        show: true,
                        to: this.$store.getters.isAuthenticated ? '/profile' : '/'
                    },
                    {
                        title: 'Top users',
                        show: this.$store.getters.isAuthenticated,
                        to: '/top'
                    },
                    {
                        title: 'Login',
                        show: !this.$store.getters.isAuthenticated,
                        to: '/login'
                    },
                    {
                        title: 'Sign out',
                        show: this.$store.getters.isAuthenticated,
                        action: this.signOut
                    },
                ]
            }
        }
    }
</script>

<style lang="scss">
  @import './assets/styles/all.scss';
  @import '../node_modules/@fortawesome/fontawesome-free/css/all.css';
  @import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
</style>
